import { QiraMessageContentChunk } from 'api3';
import { Component, inject, input } from '@angular/core';
import { ChatInputService } from '@app/services/chat-input.service';

@Component({
  selector: 'app-message-content-intent-suggestions',
  templateUrl: './message-content-intent-suggestions.component.html',
  styleUrls: [],
  imports: [],
  standalone: true,
})
export class MessageContentIntentSuggestionsComponent {
  chatInputService = inject(ChatInputService);

  tabId = input<string>();
  content = input<QiraMessageContentChunk | undefined>();

  /**
   * Hide suggestions for now -> CB-1264
   */
  // onInputChange = effect(() => {
  //   const suggestions = this.content()?.intentSuggestions;
  //   this.chatInputService.setSuggestions(this.tabId(), suggestions || []);
  // });
}
